import React, { useState, useEffect, useRef, memo, useCallback } from 'react'
import {
  Card, CardHeader, CardBody, CardFooter, ButtonGroup, Badge,
  Dropdown, DropdownToggle, DropdownMenu, DropdownItem
} from "reactstrap";
import { bytesToKB, cleanString, createFigmaPlugin, scaleElementToFitParent } from '../../../../slices/helper.js';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { approveCreative, createPreview, duplicateCreative, getComments, getCreatives, removeCreative, setAllCreativesFont, setCreativesDynamicText, setPreviewFonts, setAllCreativesDynamicText } from '../../../../slices/campaigns/thunk';
import { toggleCommentModal, toggleDeleteCreativeModal, toggleDuplicateCreativeModal, toggleDuplicateNewSizeCreativeModal, toggleFallbackModal, toggleFigmaPluginModal, togglePluginLoader } from '../../../../slices/modals/reducer';
import { setActiveDynamicText, setCampaignLoader, setCommentRelationId, setCommentType, setCreativeIdOpenedInFigma, setCreativeOpenedInFigma, setCreatives, setCurrentDynamicText, setDeleteCreativeId, setDisableSetPreview, setDuplicateCreative, setDynamicText, setFilteredCreatives, setScrolledCreatives, setSelectedCreative, setSelectedCreativeDynamicText, updateCreatives, updateScrolledCreatives } from '../../../../slices/campaigns/reducer';
import { setUploadedFiles } from '../../../../slices/uploads/reducer';
import { checkCreativeFont, loadFonts } from '../../../../slices/fonts/thunk';
import checkPermission from '../../../../Components/Hooks/PermissionHook';
import { useProfile } from '../../../../Components/Hooks/UserHooks';
import api from "../../../../config";
import { getFigmaObj, putCreative } from '../../../../helpers/backend_helper.js';
import { toast } from 'react-toastify';
import Preloader from '../../../../Components/Common/Preloader.js';
import BannerIframe from './BannerIframe.js';
import config from '../../../../config';
let apiUrl = api[api.status].apiUrl;

const BannerCard = memo((
  {
    idx,
    id,
    figma,
    figmaObject,
    type,
    size,
    thumbnail,
    comments,
    approvement,
    published,
    previewProp,
    showEdit = false,
    editableInFigmaPlugin = false,
    isCreativeCreated = true,
    updateStateAfterLoad = true,
    showHeatmap = false,
    isBannerLoadingProp = true,
    heatmapFunc,
    templatePreview,
  }) => {
  const dispatch = useDispatch();

  const selectStates = createSelector(state => state, state => ({
    brandPath: state.MenuData.brandPath,
    marketPath: state.MenuData.marketPath,
    dynamicText: state.Campaign.dynamicText,
    connectedFeed: state.Campaign.connectedFeed,
    currentCampaign: state.Campaign.currentCampaign,
    currentVersion: state.Campaign.currentVersion,
    uploadedFiles: state.Upload.uploadedFiles,
    creatives: state.Campaign.creatives,
    scrolledCreatives: state.Campaign.scrolledCreatives,
    selectedCreative: state.Campaign.selectedCreative,
  }));
  const {
    brandPath,
    marketPath,
    dynamicText,
    connectedFeed,
    currentCampaign,
    currentVersion,
    uploadedFiles,
    creatives,
    scrolledCreatives,
    selectedCreative,
  } = useSelector(selectStates);
  const { token, userId } = useProfile();
  const canEdit = checkPermission((marketPath ? "markets" : "brands"), (marketPath ? marketPath : brandPath), "campaignEdit");
  const [isBannerLoading, setIsBannerLoading] = useState(isBannerLoadingProp);
  const [isListening, setIsListening] = useState(true);
  const [figmaObjectState, setfigmaObjectState] = useState(null);
  const [creativeDynamicText, setCreativeDynamicText] = useState(null);
  const [scalePercentage, setScalePercentage] = useState(100);
  const [preview, setPreview] = useState(previewProp);
  const [isAnimPlaying, setIsAnimPlaying] = useState(true);
  const [editDropdown, setEditDropdown] = useState(false);
  const iframeCont = useRef();
  const loaderCont = useRef();
  const previewCont = useRef();

  useEffect(() => {
    setIsBannerLoading(isBannerLoadingProp);
  }, [isBannerLoadingProp])

  useEffect(() => {
    setPreview(previewProp);
  }, [previewProp])

  useEffect(() => {
    if (isBannerLoading === true) {
      scaleElementToFitParent(loaderCont?.current, setScalePercentage, 50);
      window.addEventListener('resize', () => scaleElementToFitParent(loaderCont?.current, setScalePercentage, 50));
    } else {
      window.removeEventListener('resize', () => scaleElementToFitParent(loaderCont?.current, setScalePercentage, 50))
    }
  }, [isBannerLoading]);

  useEffect(() => {
    if (type === 'html') {
      if (preview && typeof preview !== 'boolean') {
        previewCont.current.appendChild(preview);
        scaleElementToFitParent(preview, setScalePercentage, 50);
        window.addEventListener('resize', () => scaleElementToFitParent(preview, setScalePercentage, 50));
        if (figmaObject) {
          setfigmaObjectState(figmaObject);
        }
      } else if (!preview && !isBannerLoading && figmaObject) {  
        setfigmaObjectState(figmaObject);
        setPreview(true);
        setIsBannerLoading(true);
      }
    }
    try {
      return () => {
        window.removeEventListener('resize', () => scaleElementToFitParent(previewCont.current?.children[0], setScalePercentage, 50));
      };
    } catch (error) {

    }
  }, [preview]);

  // // HTML
  // useEffect(() => {
  //   if (figmaObjectState) {

  //     previewCont.current.appendChild(iframeEl);
  //     scaleElementToFitParent(iframeEl, setScalePercentage, 50);
  //     setPreview(iframeEl);
  //     window.addEventListener('resize', () => scaleElementToFitParent(iframeEl, setScalePercentage, 50));
  //   } else {
  //     try {
  //       return () => {
  //         window.removeEventListener('resize', () => scaleElementToFitParent(previewCont.current?.children[0], setScalePercentage, 50));
  //       };
  //     } catch (error) {

  //     }
  //   }
  // }, [previewCont.current, figmaObjectState]);

  useEffect(() => {
    async function createHtmlCreative() {
      let figmaObjectData = await getfigmaObjectData(figma);
      createPreview(figmaObjectData, isCreativeCreated, dynamicText, connectedFeed, false);
    }
    if (isBannerLoading) {
      if (type === 'html' && figma && !figmaObjectState && !preview && isCreativeCreated) {
        createHtmlCreative();
      } else if (type === 'html' && figma && figmaObjectState && preview === true && isCreativeCreated) {
        setPreview(null);
        createPreview(JSON.parse(JSON.stringify(figmaObjectState)), isCreativeCreated, dynamicText, connectedFeed, true);
      } else if (type === 'html' && figma && figmaObject && !isCreativeCreated && templatePreview) {
        templatePreview.style.display = 'block';
        if (previewCont.current?.children[0]) {
          previewCont.current?.children[0].remove();
        }
        // dispatch(checkCreativeFont(figmaObject));
        setPreview(templatePreview);
        previewCont.current.appendChild(templatePreview);
        scaleElementToFitParent(previewCont.current?.children[0], setScalePercentage, 50);
        setIsBannerLoading(false);
        window.addEventListener('resize', () => scaleElementToFitParent(previewCont.current?.children[0], setScalePercentage, 50));
      } else {
        window.removeEventListener('resize', () => scaleElementToFitParent(previewCont.current?.children[0], setScalePercentage, 50));
      }
    }
  }, [figma, figmaObject, figmaObjectState]);

  useEffect(() => {

    async function listenPlugin(event) {
      if (event?.data) {
        if (event.data.action === 'adc-creative-resource-size') {
          // setBannerResourceSize(event.data.size);
        } else if (event.data.action === 'adc-animation-toggled') {

          if (id === event.data.creativeId) {
            setIsAnimPlaying(event.data.isPlaying);
          }
        }
      }
    }

    if (isListening) {
      window.addEventListener('message', async (event) => await listenPlugin(event));
    } else {
      window.removeEventListener('message', async (event) => await listenPlugin(event));
    }

    return () => {
      window.removeEventListener('message', async (event) => await listenPlugin(event));
    };
  }, [isListening]);

  // IMAGE
  useEffect(() => {
    if (thumbnail) {
      if (type === 'image') {
        if (previewCont.current?.children[0]) {
          previewCont.current?.children[0].remove();
        }
        const imgEl = document.createElement('img');
        imgEl.style.visibility = 'hidden';
        imgEl.src = thumbnail;
        previewCont.current.appendChild(imgEl);
        imgEl.onload = () => {
          imgEl.style.visibility = 'visible';
          scaleElementToFitParent(previewCont.current?.children[0], setScalePercentage, 50);
          setIsBannerLoading(false);
        }
        window.addEventListener('resize', () => scaleElementToFitParent(previewCont.current?.children[0], setScalePercentage, 50));
      }
      return () => {
        window.removeEventListener('resize', () => scaleElementToFitParent(previewCont.current?.children[0], setScalePercentage, 50));
      };
    }
  }, [thumbnail]);

  const getfigmaObjectData = useCallback(async (figma) => {
    const figmaObj = await getFigmaObj(`${figma}?timestamp=${new Date().getTime()}`);
    return figmaObj
  }, []);

  const createIframe = useCallback(async (previewCont, figmaObjectState, creativeDynamicText, connectedFeed) => {
    if (previewCont.current.children[0]) {
      previewCont.current.children[0].remove()
    }
    const iframeEl = document.createElement('iframe');
    iframeEl.src = config[config.status].previewUrl;
    iframeEl.width = `${size.split('x')[0]}px`;
    iframeEl.height = `${size.split('x')[1]}px`;
    iframeEl.style.pointerEvents = 'none';
    iframeEl.style.userSelect = 'none';
    iframeEl.onload = () => {
      iframeEl.contentWindow.postMessage({
        action: 'adc-get-preview',
        previewObject: {
          node: figmaObjectState?.node,
          animation: figmaObjectState?.animation,
          actions: figmaObjectState?.actions,
          actionCss: figmaObjectState?.actionCss,
          version: currentVersion,
          dynamicText: [creativeDynamicText],
          globalLoop: figmaObjectState?.globalLoop,
          dynamicLoop: figmaObjectState?.dynamicLoop,
          feedObjects: connectedFeed,
          creativeId: id
        },
        creativeId: id,
        fonts: ''
      }, '*');
      setIsBannerLoading(false);
      if (updateStateAfterLoad) {
        updateScrolledCreativesState(figmaObjectState, iframeEl);
      }
    };
    return iframeEl;
  }, []);

  const createPreview = useCallback(async (figmaObj, isCreativeCreated = true, dynamicText, connectedFeed, isCreateIframe = false) => {
    let foundDynamicText;
    if (isCreativeCreated) {
      foundDynamicText = findDynamicText(dynamicText, id);
      if (!isCreateIframe) {
        figmaObj = updateFigmaObjBeforePreview(figmaObj, foundDynamicText, connectedFeed);
        const fonts = await dispatch(loadFonts(figmaObj));
        figmaObj.node.googlefont.style = fonts;
        figmaObj.node.adcfont.style = fonts;
      }
    }
    // dispatch(checkCreativeFont(figmaObj));
    setfigmaObjectState(figmaObj);
    if (isCreateIframe) {
      const iframeEl = await createIframe(previewCont, figmaObj, foundDynamicText, connectedFeed);
      setPreview(iframeEl);
    } else {
      setPreview(true);
    }
  }, []);

  const updateFigmaObjBeforePreview = useCallback((figmaObj, foundDynamicText, connectedFeed) => {
    let finalObj = { ...figmaObj };
    if (foundDynamicText) {
      setCreativeDynamicText(foundDynamicText);
      const texts = foundDynamicText.texts;
      let k = 0;
      do {
        const elIds = Object.keys(finalObj.node);
        if (texts[k]?.type === "text") {
          let l = 0;
          do {
            if (finalObj.node[elIds[l]].hasOwnProperty("name")) {
              if (cleanString(finalObj.node[elIds[l]].name) === cleanString(texts[k].name)) {
                finalObj.node[elIds[l]].characters = texts[k].value;
                try {
                  if (texts[k]?.isFeed) {
                    const foundFeed = connectedFeed.find(item => item.path === finalObj.node[elIds[l]].characters);
                    if (foundFeed !== undefined && foundFeed !== null) {
                      finalObj.node[elIds[l]].characters = `${foundFeed.values[0]}`;
                    }
                  }
                } catch (error) {
                  finalObj.node[elIds[l]].characters = texts[k].value;
                }
                break;
              }
            }
            l++;
          } while (l < elIds.length);
        } else if (texts[k]?.type === "image") {
          let l = 0;
          do {
            if (finalObj.node[elIds[l]].hasOwnProperty("name")) {
              if (cleanString(finalObj.node[elIds[l]].name) === cleanString(texts[k].name)) {
                if (texts[k].value && texts[k].value !== '' && texts[k].value !== ' ') {
                  finalObj.node[elIds[l]].bgimages["1x"].data = texts[k].value;
                  finalObj.node[elIds[l]].bgimages["2x"].data = texts[k].value;
                  break;
                }
              }
            }
            l++;
          } while (l < elIds.length);
        }
        k++;
      } while (k < texts.length);
    }
    return finalObj;
  }, []);

  const findDynamicText = useCallback((dynamicText, creativeId) => {
    if (dynamicText) {
      let foundDynamicText = dynamicText.find(dItem => dItem.isCreative === true && dItem.creativeId === creativeId);
      if (!foundDynamicText) {
        foundDynamicText = dynamicText[0];
      }
      return foundDynamicText;
    }
    return null;
  }, []);

  const updateScrolledCreativesState = useCallback((figmaObjParam, previewParam) => {
    if (isCreativeCreated) {
      const foundScrolledCreative = scrolledCreatives.find(creative => creative._id === id);
      dispatch(updateScrolledCreatives({ ...foundScrolledCreative, preview: previewParam, figmaObject: figmaObjParam, isLoading: false }));
      const foundCreative = creatives.find(creative => creative._id === id);
      dispatch(updateCreatives({ ...foundCreative, preview: previewParam, figmaObject: figmaObjParam, isLoading: false }));
    }
  }, []);

  const toggleAnim = useCallback((event) => {
    event.stopPropagation();
    preview?.contentWindow.postMessage({
      action: 'adc-play-preview',
      creativeId: id
    }, '*');
  }, [preview]);

  const replayAnim = useCallback((event) => {
    event.stopPropagation();
    preview?.contentWindow.postMessage({
      action: 'adc-replay-preview',
      creativeId: id
    }, '*');
  }, [preview]);

  const editInFigmaPlugin = useCallback(() => {
    dispatch(toggleFigmaPluginModal(true));
    // dispatch(togglePluginLoader());
    setTimeout(async () => {
      const iframe = createFigmaPlugin();
      iframe.onload = () => {
        iframe.contentWindow.postMessage({
          action: 'adc-login-control',
          token: token,
          userid: userId,
          isPlatform: true,
          isCreativeCreated: isCreativeCreated
        }, '*');
        // console.log('postMessageData', {
        //   action: 'adc-show-frames',
        //   data: {
        //     "brandId": brandPath,
        //     "creativeId": id,
        //     "version": currentVersion,
        //     "dynamicText": [creativeDynamicText],
        //     "animation": figmaObjectState?.animation,
        //     "node": figmaObjectState?.node,
        //     "actions": figmaObjectState?.actions,
        //     "actionCss": figmaObjectState?.actionCss,
        //     "campaignId": currentCampaign._id,
        //     "dynamicLoop": figmaObjectState?.dynamicLoop,
        //     "globalLoop": figmaObjectState?.globalLoop,
        //     "feedObjects": connectedFeed
        //   }
        // });
        iframe.contentWindow.postMessage({
          action: 'adc-show-frames',
          data: {
            "brandId": brandPath,
            "creativeId": id,
            "version": currentVersion,
            "dynamicText": [creativeDynamicText],
            "animation": figmaObjectState?.animation,
            "node": figmaObjectState?.node,
            "actions": figmaObjectState?.actions,
            "actionCss": figmaObjectState?.actionCss,
            "campaignId": currentCampaign._id,
            "dynamicLoop": figmaObjectState?.dynamicLoop,
            "globalLoop": figmaObjectState?.globalLoop,
            "feedObjects": connectedFeed
          }
        }, '*');
        const foundCreative = scrolledCreatives.find(creative => creative._id === id);
        // dispatch(updateScrolledCreatives({ ...foundCreative, isLoading: false }));
        // dispatch(updateCreatives({ ...foundCreative, isLoading: false }));
        dispatch(setCreativeOpenedInFigma(foundCreative));
        // setIsBannerLoading(false);
        // setIsListening(true);
      }
    }, 500);
  }, [creativeDynamicText, figmaObjectState, connectedFeed, currentVersion]);

  const duplicateSelectedCreative = useCallback((event) => {
    event.stopPropagation();
    if (isCreativeCreated) {
      const foundCreative = scrolledCreatives.find(creative => creative._id === id);
      dispatch(setDuplicateCreative(foundCreative));
      dispatch(toggleDuplicateCreativeModal());
    } else {
      const duplicateUploadedFiles = uploadedFiles.find((item, itemIdx) => itemIdx === idx);
      const duplicatedFile = { ...duplicateUploadedFiles }
      if (duplicatedFile) {
        dispatch(setUploadedFiles([...uploadedFiles, duplicatedFile]));
      }
    }
  }, []);

  const duplicateWithNewSizeCreative = useCallback((event) => {
    event.stopPropagation();
    const foundCreative = scrolledCreatives.find(creative => creative._id === id);
    dispatch(setDuplicateCreative(foundCreative));
    dispatch(toggleDuplicateNewSizeCreativeModal());
  }, []);

  const removeSelectedCreative = useCallback((event) => {
    event.stopPropagation();
    if (isCreativeCreated) {
      dispatch(setDeleteCreativeId(id));
      dispatch(toggleDeleteCreativeModal());
    } else {
      const filteredUploadedFiles = uploadedFiles.filter((item, itemIdx) => itemIdx !== idx);
      if (filteredUploadedFiles) {
        dispatch(setUploadedFiles(filteredUploadedFiles));
      }
    }
  }, []);

  const openComments = useCallback(async (event) => {
    event.stopPropagation();
    dispatch(setCommentRelationId(id));
    dispatch(setCommentType("creative"));
    await dispatch(getComments({ type: "creative", relationId: id }));
    dispatch(toggleCommentModal());
  }, []);

  function selectCreative() {
    if (type === 'html' && isCreativeCreated && dynamicText && preview && figmaObjectState) {
      if (selectedCreative === null || selectedCreative._id !== id) {
        const foundCreative = scrolledCreatives.find(creative => creative._id === id);
        dispatch(setSelectedCreative(foundCreative));
        if (dynamicText.length > 1) {
          const foundCreativeDynamicText = dynamicText.find(text => text.isCreative === true && text.creativeId === id);
          if (foundCreativeDynamicText) {
            dispatch(setActiveDynamicText(null));
            setTimeout(() => {
              dispatch(setActiveDynamicText({ ...foundCreativeDynamicText }));
            }, 1);
          } else {
            dispatch(setActiveDynamicText(null));
            setTimeout(() => {
              dispatch(setActiveDynamicText(dynamicText[0]));
            }, 1)
          }
        } else {
          dispatch(setActiveDynamicText(null));
          setTimeout(() => {
            dispatch(setActiveDynamicText({ ...dynamicText[0] }));
          }, 1);
        }
      } else {
        dispatch(setSelectedCreative(null));
        dispatch(setActiveDynamicText(null));
        setTimeout(() => {
          dispatch(setActiveDynamicText(dynamicText[0]));
        }, 1)
      }
    }
  }

  function isCreativeApproved() {
    if (approvement) {
      return ' card-approved';
    } else {
      return ' ';
    }
  }

  function isCreativeSelectable() {
    if (type === 'html' && dynamicText !== null) {
      return ' cursor-pointer';
    } else {
      return ' ';
    }
  }

  function isCreativeSelected() {
    if (type === 'html' && isCreativeCreated && selectedCreative !== null) {
      if (selectedCreative?._id === id) {
        return ' selected-creative';
      } else {
        return '';
      }
    } else {
      return ' ';
    }
  }

  return (
    <Card
      style={{ minHeight: "550px", maxHeight: "550px" }}
      className={"border" + isCreativeApproved() + isCreativeSelectable() + isCreativeSelected()}
      onClick={selectCreative}
    >
      <CardHeader className='d-flex py-2 align-items-center justify-content-between'>
        <p className='size m-0'>{(size || '')}</p>
        <div className='d-flex gap-1 align-items-center'>
          {type === "html" && figmaObjectState ?
            <React.Fragment>
              <button className='btn btn-sm btn-icon btn-light' onClick={toggleAnim}>
                {isAnimPlaying ?
                  <i className='ri-pause-fill'></i>
                  :
                  <i className='ri-play-fill'></i>
                }
              </button>
              <button className='btn btn-sm btn-icon btn-light' onClick={replayAnim}>
                <i className='mdi mdi-replay'></i>
              </button>
              {showHeatmap ?
                <button className={'btn btn-sm btn-icon btn-light'} onClick={heatmapFunc}>
                  <i className='ri ri-temp-cold-line'></i>
                </button>
                : null}
            </React.Fragment>
            : null}
          {canEdit && showEdit && (type === 'html' ? figmaObjectState : true) ?
            <Dropdown isOpen={editDropdown} toggle={(e) => {
              e.stopPropagation()
              setEditDropdown(!editDropdown)
            }
            }>
              <DropdownToggle className='btn btn-icon btn-light'>
                <i className='ri-more-fill align-middle' style={{ transform: "rotate(90deg)" }}></i>
              </DropdownToggle>
              <DropdownMenu>
                {editableInFigmaPlugin ?
                  <DropdownItem onClick={editInFigmaPlugin}>
                    <i className='mdi mdi-square-edit-outline align-bottom me-1'></i>
                    Edit Banner
                  </DropdownItem>
                  : null}
                <DropdownItem onClick={duplicateSelectedCreative}>
                  <i className='mdi mdi-card-multiple-outline align-bottom me-1'></i>
                  Duplicate
                </DropdownItem>
                {type === 'html' ?
                  <DropdownItem onClick={duplicateWithNewSizeCreative}>
                    <i className='mdi mdi-card-multiple-outline align-bottom me-1'></i>
                    Duplicate With Resize
                  </DropdownItem>
                  : null}
                <DropdownItem onClick={removeSelectedCreative}>
                  <i className='ri-delete-bin-2-line align-bottom me-1'></i>
                  Remove
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            : null}
        </div>
      </CardHeader>
      <CardBody className='d-flex align-items-center justify-content-center position-relative'>
        <div className='w-100 h-100 p-3 d-flex position-absolute' ref={previewCont}>
          {/* <BannerIframe ref={iframeCont} width={size.split('x')[0]} height={size.split('x')[1]} /> */}
        </div>
        {isBannerLoading === true ?
          <div className='w-100 h-100 p-3 d-flex position-absolute'>
            <div className='skeleton-loader' ref={loaderCont} style={{ width: `${size.split('x')[0]}px`, height: `${size.split('x')[1]}px` }}></div>
          </div>
          : null}
      </CardBody>
      <CardFooter className='d-flex align-items-center justify-content-between'>
        <span className='badge bg-dark-subtle text-muted fs-11'>0 KB</span>
        <div className='d-flex align-items-center gap-1'>
          {showEdit ?
            <React.Fragment>
              <button className='btn btn-icon btn-sm btn-light text-muted bg-transparent border-0 fs-12'
                onClick={openComments}
              >
                {comments > 0 ?
                  <React.Fragment>
                    <i className='ri-question-answer-fill'></i>
                    <span className='mt-1' style={{ marginLeft: "2px" }}>{comments}</span>
                  </React.Fragment>
                  :
                  <i className='bx bx-comment-add align-middle'></i>
                }
              </button>
              <button
                className={'btn btn-icon btn-sm btn-light fs-12 bg-transparent border-0 ' + (approvement ? "text-success" : "text-muted")}
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(approveCreative([id]))
                }}
              >
                <i className='ri-thumb-up-fill align-middle'></i>
              </button>
              <button className={'btn btn-icon btn-sm btn-light fs-13 bg-transparent border-0 ' + (published ? "text-info" : "text-muted")} onClick={(event) => event.stopPropagation()}>
                <i className='mdi mdi-rocket-outline align-bottom'></i>
              </button>
            </React.Fragment>
            : null}
        </div>
        <span className='badge bg-dark-subtle text-muted fs-11'>{scalePercentage.toFixed(2) + '%'}</span>
      </CardFooter>
    </Card >
  )
});

export default BannerCard;